module.exports = __webpack_public_path__ + "static/media/level-down-alt.a25f2884.svg";